

















import { Component, Vue, Prop } from 'vue-property-decorator';

//import Banner from '@/components/Banner.vue';
import Banner from '@/components/NewBanner.vue';
import OverlappingTextImage from '@/components/OverlappingTextImage.vue';
import GlobalPresence from '@/components/GlobalPresence.vue';
import LogisticService from '@/components/LogisticService.vue';
import Gtrack from '@/components/Gtrack.vue';

import {
  TimelineMax,
  CSSPlugin,
  CSSRulePlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo
} from 'gsap/all';

import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

@Component({
  name: 'HomePage',
  components: {
    slider: Banner,
    overlapping_text_image: OverlappingTextImage,
    double_image_title_text_cta: GlobalPresence,
    LogisticService,
    Gtrack
  }
})
export default class HomePage extends Vue {
  public height: any = window.innerHeight;
  public width: any = window.innerWidth;
  @Prop() pageData: any;
}
